import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";

// project-import
import KnowledgeCard from "../knowledge-card/KnowledgeCard";
import KnowledgeCardDetail from "../knowledge-card/KnowledgeCardDetail";
import SectionTitle from "../sectionTitle/SectionTitle";
import SalesforceKnowledgeCardStencil from "../knowledge-card/stencils/SalesforceKnowledgeCardStencil";
import { useBlogContext } from "../../context/blog_context";
import KnowledgeArticle from "../knowledge-card/KnowledgeArticle";
import { useQuickInsightContext } from "../../context/quick_insights_context";
import ErrorComponent from "../error-message/ErrorComponent";

function SalesforceKnowledgeCard() {
  // Extracting variable from context
  const { isLoading, quickInsights, isError } = useQuickInsightContext();
  const navigate = useNavigate();
  const { insight } = useParams();

  // State initalization
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  // To show Data
  const data = quickInsights && quickInsights?.length ? quickInsights?.slice(0, 6) : [];

  // Find index of current Tab
  const currentIndex =
    data &&
    data.length &&
    data?.findIndex((elm) => elm?.title === selectedArticle?.title);

  // Find  prev index
  const prevIndex = currentIndex ? currentIndex - 1 : -1;

  // Find prev Tab
  const prevData =
    prevIndex !== -1 ? (data && data.length ? data[prevIndex] : null) : null;

  // Find next index
  const nextIndex = currentIndex ? (currentIndex + 1) % data?.length : +1;

  // Find next Tab
  const nextData = nextIndex ? data[nextIndex] : null;

  const handleReadMore = (article) => {
    const slug = encodeURIComponent(article.title.toLowerCase().replace(/ /g, '-'));

    setSelectedArticle(article);

    navigate(`/salesforce-quick-insights/${slug}`, {
      replace: false,
    });

  };

  // 4. Close modal by removing the parameter from the URL
  const handleReadMoreClose = () => {
    setSearchParams({});
    setSelectedArticle(null);
  };

  useEffect(() => {

    if (!selectedArticle) {

      //  Extract the specific parameter (returns null if not present)
      const filteredArticles = (quickInsights || []).filter((item) => encodeURIComponent(item?.title.toLowerCase().replace(/ /g, '-')) === insight);

      if (filteredArticles && filteredArticles.length) {
        setSelectedArticle(filteredArticles[0]);
      }
    }
  }, []);

  if (isLoading) {
    return <SalesforceKnowledgeCardStencil />;
  }

  return (
    <div>
      <div className="edu-course-area eduvibe-home-one-blog bg-image edu-section-gap">
        <div className="container eduvibe-animated-shape">
          <div className="row g-5 y-gap-15 align-items-center justify-content-between">
            <div className="col-12 col-lg-6">
              <div className="section-title text-start">
                <span className="pre-title">
                  Across the Salesforce ecosystem
                </span>
                <h3 className="title">Salesforce Quick Insights</h3>
              </div>
            </div>
            <div className="col-auto">
              <div className="load-more-btn">
                <Link className="button -icon -outline-purple-1 color-primary"
                  to="/salesforce-quick-insights/all"
                >
                  View All<i class="ri-arrow-right-up-line ml--10"></i>
                </Link>
              </div>
            </div>
          </div>
          {!isLoading && isError ?
            <div className="row g-5 mt--10 text-center">
              <ErrorComponent errorCode="500" mainError={`No salesforce quick-insights are available!`} subText={`Currently no salesforce quick-insights are available. Please be back later.`} buttonText="Back to Home" link='/' />
            </div>
            :
            (!isLoading && !isError && data && !data.length) ?
              // <ErrorComponent errorCode="404" mainError="Oops...! No Courses are available." />
              <ErrorComponent errorCode="404" mainError={`Failed to get salesforce quick insights right now.`} subText="Please return to the site's homepage, It looks like nothing was found at this location" buttonText="Back to Home" link='/' />
              :
              <>
                <div className="row y-gap-30 pt--50">
                  {(data || []).map((item) => (
                    <div key={item?.id} className="col-12 col-xl-4 col-lg-4">
                      <KnowledgeCard data={item} onReadMore={handleReadMore} />
                    </div>
                  ))}
                </div>
              </>
          }

        </div>
      </div>

      <KnowledgeArticle
        selectedArticle={selectedArticle}
        setArticle={setSelectedArticle}
        prevData={prevData}
        nextData={nextData}
        onReadMore={handleReadMore}
        onReadMoreClose={handleReadMoreClose}
      />
    </div>
  );
}

export default SalesforceKnowledgeCard;
